import { Injectable, Injector } from "@angular/core";
import { Service } from "@services/service";

@Injectable()
export class PackagingService extends Service {
	constructor(injector: Injector) {
		super("Packaging", injector);
	}
}